<template>
    <div class="tree__drag-modal" v-show="dragModal">
        <div class="search-alert-active__background"></div>
        <div class="search-alert-active__wrapper">
            <div class="search-alert-active__header">
                <div class="search-alert-active__title">Confirm changes</div>
                <icon class="search-alert-active__icon" icon="close" color="#fff" :width="20" :height="20" @click.native="cancelTreeModal"></icon>
            </div>
            <div class="search-alert-active__text">{{ text }}</div>
            <div v-if="treeViewOnlyItems">
                <treeview-node-read-only tree-name="read-only-tree" :level="0" :value="treeViewOnlyItems" class="tree-read-only"></treeview-node-read-only>
            </div>
            <div class="search-alert-active__btn-wrapper">
                <sp-btn class="search-alert-active__btn" text="CANCEL" @click.native="cancelTreeModal"></sp-btn>
                <sp-btn class="search-alert-active__btn" text="CONFIRM" icon="download" @click.native="confirmTreeModal"></sp-btn>
            </div>
        </div>
    </div>
</template>

<script>
import SpBtn from '@/components/forms/SpBtn'
import Icon from '@/components/atoms/Icon'
import { mapGetters } from 'vuex'
import TreeviewNodeReadOnly from '@/views/Tree/TreeviewNodeReadOnly'
import _ from 'lodash-es'

export default {
    name: 'AlertModal',
    components: {
        TreeviewNodeReadOnly,
        SpBtn,
        Icon
    },
    data () {
        return {
            treeViewOnlyItems: null
        }
    },
    props: {
        dragModal: Boolean,
        sourceItem: {
            type: Object,
            required: false,
            default () {
                return {}
            }
        },
        destinationItem: {
            type: Object,
            required: false,
            default () {
                return {}
            }
        },
        text: String
    },
    watch: {
        dragModal: {
            handler (value) {
                if (value) {
                    const items = this.getNode(this.latestFullTree[0], this.sourceItem.id)
                    this.treeViewOnlyItems = _.cloneDeep(items)
                }
            },
            deep: true
        }
    },
    computed: {
        ...mapGetters({
            latestFullTree: 'organizationTreeModule/latestFullTree'
        })
    },
    methods: {
        cancelTreeModal (isCancel) {
            this.$emit('cancelTreeModal', isCancel)
        },
        confirmTreeModal (isConfirm) {
            this.$emit('confirmTreeModal', isConfirm)
        },

        getNode (node, id) {
            if (node.id === id) {
                return node
            }

            for (const node of node.items) {
                const value = this.getNode(node, id)
                if (value) return value
            }
        }
    }
}
</script>

<style scoped lang="scss">
.tree__drag-modal {
    display: block;
    position: absolute;
    z-index: 999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    cursor: auto;
}

.search-alert-active {
    display: block;
    position: absolute;
    z-index: 999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    cursor: auto;

    &__wrapper {
        display: flex;
        flex-direction: column;
        box-shadow: 0 0 15px #9d9999;
        margin: 100px auto 0;
        width: 500px;
        position: relative;
        z-index: 999;
        border-radius: 6px;
        background-color: $white;
    }

    &__background {
        position: absolute;
        opacity: 0.7;
        z-index: 9;
        background-color: #eee;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
    }

    &__header {
        display: flex;
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
        background-color: $secondary-default;
        align-items: center;
        padding: 15px 20px;
    }

    &__icon {
        cursor: pointer;
        transition: 0.3s;

        &:hover {
            opacity: 0.5;
        }
    }

    &__title {
        font-size: 18px;
        color: $white;
        font-weight: 700;
        margin: 0 auto 0 10px;
    }

    &__text {
        padding: 15px 20px;

        span {
            font-weight: 700;
        }
    }

    &__label {
        padding: 0 20px;
        font-size: 14px;
        font-weight: 700;
    }

    &__select {
        width: 92%;
        margin: 0 auto;

        ::v-deep .v-input__slot {
            border: 2px solid #eeeeee !important;
            border-radius: 10px !important;
            min-height: 50px !important;
        }
    }

    &__btn-wrapper {
        padding: 10px 20px 20px;
        display: flex;
        justify-content: space-between;
    }

    &__btn {
        background-color: $secondary-default !important;
    }
}

.tree-read-only {
    overflow-y: scroll;
    max-height: 260px;
}
</style>
